export default "__VITE_ASSET__DYx2y0z2__"